import {PreparationModifierEntityModel} from "../preparation-modifier-entity-model.service";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {EntityModelStatus, provideEntityModel} from "@fedeltapointofsale/data-client";
import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy} from "@angular/core";
import {MetaTagDefinitionData, MetaTagType} from "../../meta-tag/meta-tag.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {first, Subscription} from "rxjs";

@Component({
    selector: "wbo-preparation-modifier-edit-page",
    templateUrl: "./preparation-modifier-edit-page.component.html",
    providers: [provideEntityModel(PreparationModifierEntityModel)]
})
export class PreparationModifierEditPageComponent extends AbstractEditPage implements AfterViewInit, OnDestroy {
    fixedType: MetaTagType;

    MetaTagType = MetaTagType;

    private subscriptions: Subscription = new Subscription();

    constructor(public model: PreparationModifierEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    get isLocalisedType(): boolean {
        return this.model.data.type === MetaTagType.PREPARATION;
    }

    get isValuedType(): boolean {
        return this.model.data.type === MetaTagType.PREPARATION;
    }

    selectType(): void {
        if (!this.isLocalisedType) {
            this.model.data.localisableContext.universal = true;
        }
    }

    ngAfterViewInit(): void {
        this.subscriptions.add(this.model.$data.subscribe(() => {
            if (this.model.status === EntityModelStatus.INSERT && this.editParams) {
                this.fixedType = this.editParams["type"];
                if (this.fixedType) {
                    this.model.$data.pipe(first()).subscribe(() => this.model.data.type = this.fixedType);
                }
                this.changeDetectorRef.detectChanges();
            }
        }));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    addingAnother(previousEntity: MetaTagDefinitionData): void {
        this.model.data.type = previousEntity.type;
    }
}
